import React from "react";
import Images from "../../Component/Simage";

function DistributedDelivery() {
  return (
    <div className="depin_smart_storage networkCard">
      <div className="row">
        <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 order-2 order-lg-1">
          <div className="ryt_sec">
            <div>
              <p className="pre-title fw-500">Distributed Delivery</p>
              <p className="title fw-700">Network Card & Bandwidth</p>
              <p className="des fw-300 mb-0">
                Your spare network bandwidth is utilized to send media and data,
                via your AInfra DePIN, to users and dApps on AInfra Network.
                This method ensures lightning fast delivery whilst retaining
                high data quality.
              </p>
            </div>
          </div>
        </div>
        <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 order-1 order-lg-2 mb-4 mb-lg-0">
          <div className="left_sec">
            <img
              src={Images.distributeDelivery}
              className="img-fluid img_src"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default DistributedDelivery;
